function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function MobilephoneBill(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1c1.103 0 2 .897 2 2v18c0 1.103-.897 2-2 2H7c-1.104 0-2-.897-2-2V3c0-1.103.896-2 2-2h10.5zm.001 17.394h-10.5V21h10.5v-2.606zm-5.299.36a.951.951 0 110 1.901.951.951 0 010-1.902zM17.5 6.371H7v10.022h10.501V6.372zm-5.112.781a.5.5 0 01.5.5v.343c.84.174 1.6.787 1.613 1.782a.501.501 0 01-.494.507H14a.5.5 0 01-.5-.493c-.008-.603-.631-.834-1.073-.847l-.04.003-.05-.004-.11.001c-.424.009-.828.058-1.046.268a.605.605 0 00-.106.723c.193.322.657.477 1.117.608l.539.147c.576.174 1.2.427 1.55 1.013.376.625.26 1.448-.272 1.958-.323.309-.738.443-1.122.502v.335a.5.5 0 01-1 0v-.3c-.942-.088-1.874-.72-1.887-1.824a.5.5 0 01.493-.507c.24.022.503.218.507.493.007.622.669.848 1.11.848.092 0 .183-.001.273-.005.382-.015.734-.072.934-.265a.603.603 0 00.107-.721c-.175-.293-.57-.445-.97-.566l-.531-.145c-.628-.18-1.326-.422-1.706-1.058a1.6 1.6 0 01.272-1.96c.402-.383.948-.497 1.398-.53v-.306a.5.5 0 01.5-.5zM17.5 3H7v1.372h10.5V3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoMobilephoneBill = /*#__PURE__*/React.memo(MobilephoneBill);
export default MemoMobilephoneBill;